<template>
  <div v-if="showButton">
    <button type="button" v-if="!showConfirmation" @click="showConfirmation = !showConfirmation" class="btn btn-brand1">{{ $t(i18nMessage) }}</button>

    <div v-if="showConfirmation" class="col-12 bg-danger-teres p-3 justify-content-center" role="alert">
        <div class="d-block w-100 mb-2">{{ $t('common.panicLong') }}</div>
        <div class="d-flex align-items-center justify-content-end">
          <button type="button" @click="showConfirmation = !showConfirmation" class="btn btn-danger-cancel mr-3">{{ $t('common.cancel') }}</button>
          <button type="button" @click="onClick()" class="btn btn-outline-danger">{{ $t(i18nMessage) }}</button>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { userService } from "@/services/userService";

export default defineComponent({
  name: 'ButtonPanic',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.panic'
    }
  },
  data(){
    return{
      showConfirmation: false,
      showButton: false
    }
  },
  created() {
      if( (this.$store.state.personalData.title.length > 0 ||
        this.$store.state.personalData.givenName.length > 0 ||
        this.$store.state.personalData.surName.length > 0 ||
        this.$store.state.personalData.organization.length > 0 ||
        this.$store.state.personalData.email.length > 0 ||
        this.$store.state.personalData.phone.length > 0 ) ||
        this.$store.state.transactionTickets.length > 0)
    {
      this.showButton = true
    }else{
      this.showButton = false
    }
  },
  methods: {
    onClick() {
      userService.resetShoppingCart().then(() => {
          (this as any).$router.push({
            path: '/',
            query: {
              reset: 'y'
            }
          })
        })
    }
  }
});
</script>
